import { ReactNode, JSX } from 'react';
import { checkAccess } from '@/creditflowresearch/application/User/access/checkAccess';

interface ICondition {
  checks: boolean[],
  fallback?: ReactNode | JSX.Element,
  component?: ReactNode | JSX.Element,
}

interface ICheckUserAccessProps {
  conditions: ICondition[],
  children?: ReactNode | JSX.Element,
  checkFn?: (checks: boolean[]) => boolean,
  strategy?: (conditions: ICondition[], checkFn: (checks: boolean[]) => boolean) => ReactNode | JSX.Element,
}

const defaultStrategy = (
  conditions: ICondition[],
  checkFn: (checks: boolean[]) => boolean,
) => {
  for (let index = 0; index < conditions.length; index++) {
    const { checks, fallback = null, component } = conditions[index];
    const hasAccess = checkFn(checks);

    if (!hasAccess) return fallback ?? null;
    if (component) return component;
  }

  return undefined;
};

const CheckUserAccess = ({
  conditions,
  children = null,
  checkFn = checkAccess,
  strategy = defaultStrategy,
}: ICheckUserAccessProps) => {
  const result = strategy(conditions, checkFn);

  return <>{ result === undefined ? children : result }</>;
};

export default CheckUserAccess;
